import { useMemo } from 'react'
import { searchConfig } from '@cocoonspace/shared/config/search-config'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@cocoonspace/ui/components/select'
import { Trans } from '@lingui/react/macro'

import type { BookingOption } from './step-time'

const { getTimeAsMinutes } = dateTimeUtils.utils

export const TextTimeSelect = ({
	value,
	type,
	onChange,
}: {
	value: BookingOption
	type: keyof BookingOption
	onChange: (value: string) => void
}) => {
	const options = useMemo(() => {
		return searchConfig.timeSlots.filter((timeSlot) => {
			if (type === 'start') {
				return getTimeAsMinutes(value.end) > getTimeAsMinutes(timeSlot)
			}

			if (type === 'end') {
				return getTimeAsMinutes(value.start) < getTimeAsMinutes(timeSlot)
			}

			return timeSlot
		})
	}, [type, value.end, value.start])

	return (
		<Select
			onValueChange={onChange}
			value={value[type]}
		>
			<SelectTrigger
				className='text-primary h-auto w-auto rounded-[6px] border border-slate-200 px-2 py-0 font-semibold hover:border-slate-500'
				data-testid={`timepicker-${type}`}
			>
				<SelectValue />
			</SelectTrigger>

			<SelectContent className='z-50 bg-white'>
				<SelectGroup>
					{options.map((option) => (
						<SelectItem
							key={option}
							value={option}
						>
							{option}
						</SelectItem>
					))}
				</SelectGroup>
			</SelectContent>
		</Select>
	)
}

export const FooterDateTime = ({
	value,
	onChange,
}: {
	value: BookingOption
	onChange: (value: BookingOption) => void
}) => (
	<div className='flex flex-row items-center gap-x-1'>
		<Trans>
			De{' '}
			<TextTimeSelect
				onChange={(start) => onChange({ ...value, start })}
				type='start'
				value={value}
			/>{' '}
			à{' '}
			<TextTimeSelect
				onChange={(end) => onChange({ ...value, end })}
				type='end'
				value={value}
			/>
		</Trans>
	</div>
)
